export default __webpack_public_path__ + "static/media/bio_image@3x.4c761bbf.png";